export const MessageData = [
    {
        senderId: 0,
        text: "안녕하세요!",
        timestamp: new Date('2024-09-25T10:30:00'),
        read: true,
    },
    {
        senderId: 0,
        text: "1주차 세션 팀구성이 궁금합니다!",
        timestamp: new Date('2024-09-25T10:30:00'),
        read: true,
    },
    {
        senderId: 1,
        text: "안녕하세요!",
        timestamp: new Date('2024-09-25T10:35:00'),
        read: true,
    },
    {
        senderId: 1,
        text: "세오스 공개용 노션에 비상관제시어 관련하여 공지 업로드 했습니다. 참고해주세요!",
        timestamp: new Date('2024-09-25T10:35:00'),
        read: true,
    },
];
